import { Component, input, output } from '@angular/core';

import { LandingText } from '../landing.types';
import { LandingLogo } from './landing-logo.component';

@Component({
    selector: 'app-landing-footer',
    standalone: true,
    imports: [LandingLogo],
    templateUrl: './landing-footer.component.html',
    styleUrl: './landing-footer.component.scss'
})
export class LandingFooter {
    readonly text = input.required<LandingText>();

    readonly navigate = output<string>();

    readonly currentYear = new Date().getFullYear();
}
